import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

const SpecialOffer = () => {
  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
    
  return (
    <section className="py-8 md:py-12">
      <div className="container mx-auto px-4">
        <Card className="bg-gradient-to-r from-red-900 to-red-800 border-0 max-w-4xl mx-auto">
          <CardContent className="p-6 md:p-8 text-center text-white">
            <div className="space-y-3 md:space-y-4 mb-4 md:mb-6">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-yellow-300">
                <span className="line-through opacity-70">₹1996</span> ₹1050/- Only
              </div>
              <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 md:gap-6 text-sm">
                <div className="flex items-center space-x-2 justify-center sm:justify-start">
                  <span className="w-2 h-2 bg-yellow-300 rounded-full"></span>
                  <span>Lal Kitab Remedies</span>
                </div>
                <div className="flex items-center space-x-2 justify-center sm:justify-start">
                  <span className="w-2 h-2 bg-yellow-300 rounded-full"></span>
                  <span>Available in 2+ Indian Languages</span>
                </div>
                <div className="flex items-center space-x-2 justify-center sm:justify-start">
                  <span className="w-2 h-2 bg-yellow-300 rounded-full"></span>
                  <span>Gem Rudraksha Recommendation</span>
                </div>
              </div>
            </div>
            <Button 
              variant="astrology" 
              size="xl"
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 md:px-8 py-3 w-full sm:w-auto"
              onClick={handleScrollToPricing}
            >
              CHOOSE YOUR PACKAGE
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default SpecialOffer;